import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface SectionSliderPeopleProps {
    sections: string[];
    sectionPaths: { [key: string]: string };
    highlightSection?: string;
    highlightColor?: string;
    defaultColor?: string;
}

const SectionSliderPeople: React.FC<SectionSliderPeopleProps> = ({
    sections,
    sectionPaths,
    highlightSection = 'Process Map',
    highlightColor = '#D7A833',
    defaultColor = '#666'
}) => {
    const navigate = useNavigate();
    const visibleCount = 6;
    const sectionRefs = useRef(sections.map(() => React.createRef<HTMLButtonElement>()));

    // Find the index of the highlighted section
    const highlightIndex = sections.indexOf(highlightSection);

    const [currentIndex, setCurrentIndex] = useState(() => {
        return highlightIndex !== -1 ? Math.max(0, highlightIndex - Math.floor(visibleCount / 2)) : 0;
    });

    useEffect(() => {
        if (highlightIndex !== -1 && sectionRefs.current[highlightIndex]?.current) {
            sectionRefs.current[highlightIndex].current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [highlightIndex]);

    const handleNext = () => {
        if (currentIndex + visibleCount < sections.length) {
            setCurrentIndex((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    };

    const handleSectionClick = (section: string) => {
        const path = sectionPaths[section];
        if (path) navigate(path);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, mx: 3, borderBottom: 1, borderColor: 'divider', justifyContent: 'start', bgcolor: 'background.paper', borderRadius: 2 }}>
            <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
                <ChevronLeft />
            </IconButton>
            <Box sx={{ display: 'flex', overflow: 'hidden', gap: 3,width:'92%', }}>
                {sections.slice(currentIndex, currentIndex + visibleCount).map((section, index) => (
                    <Button
                        key={section}
                        ref={sectionRefs.current[currentIndex + index]}
                        onClick={() => handleSectionClick(section)}
                     
                        sx={{
                            px: 2,
                            py: 1,
                            // width:'140px',
                            borderBottom: section === highlightSection ? 3 : 0,
                            borderColor: section === highlightSection ? highlightColor : 'transparent',
                            borderRadius: 0,
                            color: section === highlightSection ? '#000' : defaultColor,
                            textTransform: 'none',
                            fontFamily: 'Avantt',
                            whiteSpace: 'nowrap',
                            minWidth: 'auto'
                        }}
                    >
                        {section}
                    </Button>
                ))}
            </Box>
            <IconButton onClick={handleNext} disabled={currentIndex + visibleCount >= sections.length}>
                <ChevronRight />
            </IconButton>
        </Box>
    );
};

export default SectionSliderPeople;
